export default "__VITE_ASSET__CgjpMCdo__"